<template>
    <div>
        <div
            v-if="showButton && !isMobile"
            class="scroll-to-top-widgets-container"
            @click="scrollToTop"
        >
            <div class="scroll-to-top-text-container">
                <img src="/img/up-arrow-icon.svg" />
                <span class="back-to-top-text">
                    {{
                        $t('advanced.back_to_top', {
                            i18nFallback: 'Back to top',
                        })
                    }}
                </span>
            </div>
        </div>
        <div v-if="showButton && isMobile" class="scroll-to-top-mobile" @click="scrollToTop">
            <img src="/img/icon-scroll-up.png" />
        </div>
    </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
@Component
@AngularDirective('vrm-scroll-to-top-widgets')
@AngularLocaleBundle('advanced')
export default class VrmScrollToTopWidgets extends Vue {
    showButton = false;
    isMobile = window.innerWidth <= 750;

    mounted() {
        window.addEventListener('scroll', this.checkScroll);
        window.addEventListener('resize', this.handleResize);
    }

    beforeDestroy() {
        window.removeEventListener('scroll', this.checkScroll);
        window.removeEventListener('resize', this.handleResize);
    }

    // Display the scroll to top button only if the user has scrolled past some length.
    checkScroll() {
        const scrollPosition = window.scrollY;
        const viewportHeight = window.innerHeight;
        //if on mobile, the user must scroll down 3 times the height of the mobile for the button to show. Scroll same as vh on desktop
        const threshold = this.isMobile ? viewportHeight * 3 : viewportHeight;
        this.showButton = scrollPosition > threshold;
    }

    handleResize() {
        this.isMobile = window.innerWidth <= 750;
    }

    scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}
</script>
